(function () {
  function numberValue(root, selector) {
    var field = root.querySelector(selector);
    return field ? Number(field.value) : NaN;
  }

  function setText(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value;
  }

  function roundToTen(value) {
    return Math.round(value / 10) * 10;
  }

  function initialise(root) {
    var form = root.querySelector('[data-macro-form]');
    var error = root.querySelector('[data-macro-error]');
    if (!form || !error) return;

    function activeValue(name) {
      var input = form.querySelector('input[name="' + name + '"]:checked');
      return input ? input.value : '';
    }

    function syncUnitFields(unit) {
      root.querySelectorAll('[data-unit-fields]').forEach(function (group) {
        group.hidden = group.getAttribute('data-unit-fields') !== unit;
      });
    }

    function convertUnits(nextUnit) {
      if (nextUnit === 'imperial') {
        var centimetres = numberValue(root, '[data-height-cm]');
        var kilograms = numberValue(root, '[data-weight-kg]');
        root.querySelector('[data-age-imperial]').value = root.querySelector('[data-age]').value;
        root.querySelector('[data-activity-imperial]').value = root.querySelector('[data-activity]').value;
        if (Number.isFinite(centimetres)) {
          var totalInches = centimetres / 2.54;
          root.querySelector('[data-height-ft]').value = Math.floor(totalInches / 12);
          root.querySelector('[data-height-in]').value = Math.round(totalInches % 12);
        }
        if (Number.isFinite(kilograms)) root.querySelector('[data-weight-lb]').value = Math.round(kilograms * 2.20462);
      } else {
        var feet = numberValue(root, '[data-height-ft]');
        var inches = numberValue(root, '[data-height-in]');
        var pounds = numberValue(root, '[data-weight-lb]');
        root.querySelector('[data-age]').value = root.querySelector('[data-age-imperial]').value;
        root.querySelector('[data-activity]').value = root.querySelector('[data-activity-imperial]').value;
        if (Number.isFinite(feet) && Number.isFinite(inches)) root.querySelector('[data-height-cm]').value = Math.round(((feet * 12) + inches) * 2.54);
        if (Number.isFinite(pounds)) root.querySelector('[data-weight-kg]').value = Math.round((pounds / 2.20462) * 10) / 10;
      }
      syncUnitFields(nextUnit);
    }

    function calculate() {
      var unit = activeValue('macro-units');
      var sex = activeValue('macro-sex');
      var goal = activeValue('macro-goal');
      var age = unit === 'imperial' ? numberValue(root, '[data-age-imperial]') : numberValue(root, '[data-age]');
      var activity = unit === 'imperial' ? numberValue(root, '[data-activity-imperial]') : numberValue(root, '[data-activity]');
      var heightCm;
      var weightKg;

      if (unit === 'imperial') {
        var feet = numberValue(root, '[data-height-ft]');
        var inches = numberValue(root, '[data-height-in]');
        var pounds = numberValue(root, '[data-weight-lb]');
        heightCm = ((feet * 12) + inches) * 2.54;
        weightKg = pounds / 2.20462;
      } else {
        heightCm = numberValue(root, '[data-height-cm]');
        weightKg = numberValue(root, '[data-weight-kg]');
      }

      var valid = age >= 18 && age <= 80 && heightCm >= 120 && heightCm <= 230 && weightKg >= 35 && weightKg <= 300 && Number.isFinite(activity);
      if (!valid) {
        error.textContent = 'Check your age, height and weight before calculating.';
        return;
      }

      error.textContent = '';
      var sexAdjustment = sex === 'female' ? -161 : 5;
      var restingCalories = (10 * weightKg) + (6.25 * heightCm) - (5 * age) + sexAdjustment;
      var maintenance = restingCalories * activity;
      var goalFactor = goal === 'fat-loss' ? 0.85 : goal === 'build' ? 1.1 : 1;
      var targetCalories = roundToTen(maintenance * goalFactor);
      var proteinFactor = goal === 'fat-loss' ? 2 : 1.8;
      var protein = Math.round(weightKg * proteinFactor);
      var fat = Math.round((targetCalories * 0.25) / 9);
      var carbohydrates = Math.max(0, Math.round((targetCalories - (protein * 4) - (fat * 9)) / 4));
      var goalLabel = goal === 'fat-loss' ? 'Fat-loss starting target' : goal === 'build' ? 'Muscle-building starting target' : 'Maintenance starting target';
      var guidance = goal === 'fat-loss'
        ? 'Use this target for two weeks, track your average morning bodyweight and adjust by 100-150 calories only if progress stalls.'
        : goal === 'build'
          ? 'Use this target for two weeks. Aim for slow, controlled weight gain and adjust by 100-150 calories from real weekly results.'
          : 'Use this target for two weeks. If your average bodyweight is stable, you have found a useful maintenance starting point.';

      setText(root, '[data-target-label]', goalLabel);
      setText(root, '[data-calories]', targetCalories.toLocaleString('en-GB'));
      setText(root, '[data-maintenance]', roundToTen(maintenance).toLocaleString('en-GB') + ' kcal');
      setText(root, '[data-protein]', protein + 'g');
      setText(root, '[data-carbs]', carbohydrates + 'g');
      setText(root, '[data-fat]', fat + 'g');
      setText(root, '[data-guidance]', guidance);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      calculate();
    });

    form.querySelectorAll('input[name="macro-units"]').forEach(function (input) {
      input.addEventListener('change', function () { convertUnits(input.value); });
    });

    syncUnitFields(activeValue('macro-units'));
    calculate();
  }

  document.querySelectorAll('[data-macro-calculator]').forEach(initialise);
})();
